<template>
    <div>
        <span class="go-index" @click="gotoPage()">返回</span>
        
        <div class="gc-list">
            <h3 style="text-align:center;">感谢有你支持!</h3> 
            <h5 style="text-align:center;padding-bottom: 0.5rem;border-bottom: 1px solid #efefef;"></h5> <!-- 日期: 2021-05-04 02:51粮草不足，事业艰难为继。 -->
            <p style="text-indent:1.4rem;">美遇运作近一年。目前尚无经费来源，前期支出，均为团队自筹。我们最近遇到一个比较紧急的经费缺口(IT基础设施的租赁费用)，希望同在相亲路上的朋友给予力所能及的支持。</p>
            <p style="text-indent:1.4rem;">筹集的经费我们将会用在平台的基本维护，实名登记，真实性提升，社群环境建设，志愿者现场保障。</p><!-- ，比如：技术团队开支 -->
            <p style="text-indent:1.4rem;">未来我们会继续为大家提供更多的脱单服务！如果你有其他方面的支持，也可以联系我们团队负责人"奶茶叔"(微信xyz112211)。</p>

        </div>
        
        <div class="div_self_0329">
                <button @click="donate_click(1)" >支持我们</button>
        </div>
         
        <div class="div_self_0329">
            <span>捐助名单</span>
            <ul class="user_info_ul">
                <li v-for="(item,index) in donate_list" :key="index" @click="gotoPage('/goods?uid='+item.donate_uid)" style="padding: 0.1rem 0;">
                    <div style="font-size: 0.6rem;width:4rem;float:left;white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{item.nickname}}</div>
                    <div style="font-size: 0.6rem;width:4rem;float:left;white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{item.donate_value}}</div>
                    <div style="font-size: 0.6rem;width:5rem;float:right;white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{item.donate_time}}</div>
                </li>
            </ul>
        </div>

        <div class="div_self_0329"></div>


        <!-- -------------------- 捐助弹窗 -------------------- -->
        <div class="donate" v-if="cshow === 1">
            <div class="donate-bg" @click="donate_click(0)"></div>
            <div class="donate-op">
                <div>
                    <span class="donate-btn" @click="payment(5)">￥5</span>
                    <span class="donate-btn" @click="payment(10)">￥10</span> 
                    <span class="donate-btn" @click="payment(20)">￥20</span>
                </div>
                <div>
                    <span style="display: block;margin: 1rem auto;font-size: 0.6rem;" @click="payment(0)">其他金额</span>
                </div>
                
            </div>
        </div>
        <!-- -------------------- 捐助弹窗 -------------------- -->
        
        <div class="div_self_0329">
            <br />
        </div>
        
        <!-- 组件使用 -->
        <syalert ref="syalert_id" />

    </div>
</template>

<script>
    
    // 组件引入
    import sy from "@/sy";
    import wx from 'weixin-js-sdk';
    import syalert from '@/components/syalert.vue';

    export default {
        components: {
            syalert,
        },
        data() {
            return {
                
                // 用于捐赠弹窗
                ctext: "",
                ctips: "",
                cshow: 0,
                
                // 捐赠列表
                donate_list: {},
            }
        },
        methods:
        {
            gotoPage: function(page) {
                if( page !== undefined )
                {
                    this.$router.push(page);
                }else{
                    this.$router.go(-1);
                }
            },
            check:function()
            {
                let $_this=this; 
                sy.http.get(
                {
                    url: this.$root.API + 'Donate/Get',
                    success: function(res)
                    {
                        console.log(res);
                        if( res.state == '0' )
                        {
                            $_this.$refs.syalert_id.syalert(res.msg);
                        }
                        if( res.state == '1' )
                        {
                            $_this.donate_list = res.data; 
                        }
                    }
                });
            },
             
            donate_click: function(tag) {
                this.cshow = tag;
            },
            payment:function(fee)
            { 
                if( fee === 0 )
                {
                    let pro = prompt("请输入金额(￥)","");
                    console.log(fee);
                    console.log(pro);
                    if (pro === null) {
                        return false;
                    }
                    fee = pro;
                }
                let $_this=this;
                sy.http.get(
                {
                    url: this.$root.API + 'Donate/Pay',
                    data:
                    {
                        way: 1,
                        fee: fee,
                    },
                    success: function(res)
                    {
                        if( res.state == 101 )
                        {
                            $_this.wxReady(res.data);
                        }
                        if( res.state == 0 || res.state == 1 )
                        {
                            $_this.$refs.syalert_id.syconfirm(res.msg, '确定', function()
                            {
                            });
                        } 
                    }
                });
            
            },
            wxReady: function(paydata)
            {
                let $_this=this;
                let $data = paydata
                wx.ready(function()
                {
                    wx.chooseWXPay({
                        timestamp: $data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr: $data.nonceStr, // 支付签名随机串，不长于 32 位
                        package: $data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType: $data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                        paySign: $data.paySign, // 支付签名
                        success: function (res)
                        {
                            // 支付成功后的回调函数
                            if(res.err_msg == 'get_brand_wcpay_request:ok')
                            {
                                alert('支付成功!');
                            }
                            if(res.err_msg == 'ok')
                            {
                                alert('支付成功!ok');
                            }
                            if(res.err_msg=='get_brand_wcpay_request:cancel')
                            {
                                alert('支付取消!');
                            }
                            if(res.err_msg=='get_brand_wcpay_request:fail')
                            {
                                alert('支付失败! ');
                            }   
                            
                            $_this.$refs.syalert_id.syalert('支付完成,感谢你的支持', 3000);
                            setTimeout(function () {
                                    $_this.check();
                            }, 3000);
                        }
                    });
                    
                });
            },
            
            
            
        },
        created(){
            this.check();
        },
    }
</script>

<style>
    .gc-list {
        padding: 0.1rem 0.5rem;

    }

    .gc-list>p {
        font-size: 0.8rem;
    }
    
    .user_info_ul li{
        margin-top: .5rem;
        margin-left:3rem;
    
        font-size: .8rem;
        width: 14rem;
        float: left;
    }
    .user_info_ul::after{
        content: "";
        clear: both;
        display: block;
    
    }

    .donate {
        position: fixed;
        
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;
        
        text-align: center;
    }
    .donate-bg {
        position: absolute;

        top: 0;
        left: 0;

        width: 100%;
        height: 100%;
        
        background: rgba(0, 0, 0, 0.5);
    }

    /* 上线后 可以频闭 */
    .donate-op
    {
        position: absolute;

        top: calc(50% - 5rem);
        left: 10%;

        width: 80%;
        height: 10rem;

        border-radius: 0.5rem;
        margin: 0 auto;
        background: rgba(255, 255, 255, 1);
    }
   .donate-btn
    {
        color: rgb(255, 96, 96);
        
        display: inline-block;
        
        /* width: 6rem; */
        
        height: 1rem;
        line-height: 1rem;
        
        margin: 4rem 0.5rem 0 0.5rem;
        padding: 0.5rem 0.5rem;
        
        font-size: 1.0rem;
        
        border-radius: 0.3rem;
        border: 1px solid rgb(255, 96, 96);
        
        
        
        /* color: white; */
        /* background-color: rgb(255, 96, 96); */
    }
</style>